{
	"title": "Διασφάλιση λογοδοσίας με την εγκατάσταση τράπεζας άνθρακα",
	"description": "Η Heidelberg Materials έχει λάβει ενδελεχή μέτρα για να εγγυηθεί την αξιοπιστία των μειώσεων άνθρακα που παράγονται από το εργοστάσιό μας τσιμέντου CCS. Για να αποτρέψουμε οποιαδήποτε πιθανότητα διπλής λογιστικής, έχουμε εφαρμόσει μια ασφαλή εικονική τράπεζα άνθρακα σε ένα δημόσιο κατανεμημένο καθολικό.",
	"traceabilityTitle": "Ιχνηλασιμότητα των μειώσεων άνθρακα"
}
